import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "../../../../components/Shared/Sidebar/Sidebar";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import {
  AuthContext,
  TabContext,
  LangContext,
} from "../../../../context/AppContext";
import HaederMenuPopup from "../../../../components/Popup/HaederMenuPopup";
import HeaderMenuCorporatePopup from "../../../../components/Popup/HeaderMenuCorporatePopup";
import LoginRegisterPopup from "../../../../components/Popup/LoginPopup";
import RegisterPopup from "../../../../components/Popup/RegisterPopup";
import ForgotPasswordModal from "../../../../components/Modal/ForgotPasswordModal";
import ThankYouModal from "../../../../components/Modal/ThankYouModal";
import HeaderCartIcon from "./component/HeaderCartIcon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import Select, { components } from "react-select";
import TabModal from "./component/TabModal";
import { api_get_account } from "../../../../api/profile/setting";
import { api_get_languages } from "../../../../api/language";
import { useEffect } from "react";
import LazyImg from "../../../../components/Image/LazyImg";
import SearchPage from "../../../../components/SearchPage/SearchPage";

// Define a custom DropdownIndicator component
const CustomDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        src="/img/icon/dropdown-icon.svg"
        alt="Dropdown Indicator"
        style={{
          border: "0 !important",
          width: "18px",
        }}
      />
    </components.DropdownIndicator>
  );
};

const HomeHeader = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { stickyMenu } = useGlobalContext();
  const { isLoggedIn, handleLogin, handleLogout, Patientid, profileChangePic } =
    useContext(AuthContext);
  const { activeTab, handleTabClick } = useContext(TabContext);
  const { selectedLanguage, handleLanguageChange } = useContext(LangContext);

  const [showLoginPage, setShowLoginPage] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [showRegistorNow, setShowRegistorNow] = useState(false);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [profilePic, setProfilePic] = useState("/img/no-image.png");
  const [isUlVisible, setIsUlVisible] = useState(false);
  const corporateList = [
    '/who-we-are',
    '/corporate-home',
    '/csr',
    '/klinik-wakaf-an-nur',
    '/news',
    '/career',
    '/procurement'
  ];

  // setup canonical
  useEffect(() => {
    let currentUrl = window.location.href
    document.querySelector('link[rel="canonical"]').setAttribute("href", currentUrl);
  }, [location.pathname])

  const handleProfileClick = () => {
    setIsUlVisible(!isUlVisible);
  };

  const handleLoginClick = () => {
    setShowLoginPage(true);
  };

  const closeLoginPage = () => {
    setShowLoginPage(false);
    setShowRegistorNow(false);
  };

  const closeRegisterPage = () => {
    setShowRegistorNow(false);
    setShowLoginPage(false);
  };

  const handleForgotPasswordClick = () => {
    setShowLoginPage(false);
    setShowForgotPassword(true);
  };

  const handleSaveButtonClick = () => {
    setShowThankYou(true);
    setShowForgotPassword(false);
  };

  const handleLoginNowButtonClick = () => {
    setShowThankYou(false);
    setShowLoginPage(true);
  };

  const handleRegisterNowClick = () => {
    setShowRegistorNow(true);
    setShowLoginPage(false);
  };

  // Function to handle login
  const handleLogicLogin = (email, password) => {
    handleLogin(email, password, closeLoginPage);
  };

  const handleTabClickWithNavigate = (tab) => {
    handleTabClick(tab);
    if (tab === "Public") {
      navigate('/home');
    } else if (tab === "Corporate") {
      navigate('/corporate-home');
    }
  };

  const fetchLanguage = async () => {
    try {
      const res = await api_get_languages();
      if (res.status) {
        setLanguageOptions(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const get_account = () => {
    api_get_account()
      .then((res) => {
        if (res?.data) {
          setProfilePic(res.data.data.account.profile_image);
        }
      })
      .catch((err) => {
        console.error("Error fetching profile image:", err);
      });
  };

  useEffect(() => {
    if (corporateList.includes(currentPath)) {
      handleTabClick("Corporate");
    }
    else {
      handleTabClick("Public");
    }
  }, [currentPath, corporateList]);

  useEffect(() => {
    fetchLanguage();
  }, []);

  useEffect(() => {
    if (isLoggedIn || Patientid) {
      get_account();
    }
  }, [isLoggedIn, Patientid]);

  return (
    <>
      <header className="header" style={{position: "relative", zIndex: 1}}>
        <div
          className={
            stickyMenu ? "header-menu-area sticky_menu" : "header-menu-area"
          }
        >
          <div className="container">
            <div className="position-relative" style={{height: "65px", alignContent: "center"}}>
              <div className="logo">
                <Link to="/">
                  <img
                    className="home-header-logo"
                    src="/img/logo/kpj-logo.svg"
                    alt="logo"
                  />
                </Link>
              </div>
              {/* <div className="position-absolute d-flex" style={{bottom: 0, right: "-39px", mixBlendMode: "lighten"}}>
                <div className="bg-black rounded-circle" style={{ height: "39px", width: "39px" }}></div>
                <div className="bg-black rounded-circle" style={{ height: "39px", width: "39px" }}></div>
                <div className="position-absolute" style={{ height: "19.5px", width: "39px", zIndex: -1, bottom: 0, left: "25%", backgroundColor: "#f3f5f7" }}></div>
              </div> */}
            </div>
            <div className="flex-grow-1 d-none d-md-block">
              <SearchPage />
            </div>
            <div
              className="main-header"
              style={{ 
                // gap: "5px"
              }}
            >
              <div className="header-menu f-right header-left">
                <div className="active-tab-container">
                  <div
                    className={`tab ${activeTab === "Public" ? "active" : ""}`}
                    onClick={() => handleTabClickWithNavigate("Public")}
                  >
                    Public
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "Corporate" ? "active" : ""
                    }`}
                    onClick={() => handleTabClickWithNavigate("Corporate")}
                  >
                    Corporate
                  </div>
                </div>
                <button
                  className="active_tab_btn"
                  onClick={() => setModalShow(true)}
                  style={{
                    position: "relative",
                    zIndex: 1
                  }}
                >
                  {activeTab}
                  <span>
                    <KeyboardArrowDownIcon />
                  </span>
                </button>
                {modalShow && (
                  <div className="modal-background">
                    <TabModal
                      isOpen={modalShow}
                      onClose={() => setModalShow(false)}
                      activeTab={activeTab}
                    />
                  </div>
                )}
              </div>
              {isLoggedIn || Patientid ? (
                <>
                  <div
                    className="header-right f-right d-none"
                    style={{ paddingRight: "20px" }}
                  >
                    <HeaderCartIcon />
                  </div>
                  <div className="header-profile f-right pos-rel d-none d-lg-block">
                    <div className="lang-icon" onClick={handleProfileClick}>
                      {profileChangePic ? (
                        <img src={profileChangePic} alt="" loading="lazy" />
                      ) : (
                        <img src={profilePic} alt="" loading="lazy" />
                      )}{" "}
                      <span>
                        <img
                          src="/img/icon/dropdown-icon.svg"
                          alt=""
                          style={{
                            border: "0",
                            width: "18px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                    {isUlVisible && (
                      <ul className="header-profile-list">
                        <li>
                          <Link to="/profile">
                            <PersonIcon />
                            <span>View Profile</span>
                          </Link>
                        </li>
                        <li id="mypurchasepage">
                          <Link to="/purchases">
                            <PhotoCameraIcon />
                            <span>My Purchases</span>
                          </Link>
                        </li>
                        <li
                          style={{ borderTop: "1px solid #F3F3F3" }}
                          onClick={handleLogout}
                        >
                          <LogoutIcon />
                          <span>Log Out</span>
                        </li>
                      </ul>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="header-right f-right d-none"
                    style={{ paddingRight: "20px" }}
                  >
                    <HeaderCartIcon />
                  </div>
                  <div className="header-login f-right pos-rel d-none d-lg-block">
                    <div className="lang-icon">
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={handleLoginClick}
                      >
                        <img
                          src="/img/icon/login-icon.svg"
                          alt=""
                          loading="lazy"
                        />
                        <span style={{ fontSize: "16px", fontWeight: "400" }}>
                          Login
                        </span>
                      </button>
                    </div>
                  </div>
                </>
              )}

              {showLoginPage && (
                <LoginRegisterPopup
                  onLogin={handleLogicLogin}
                  isOpen={showLoginPage}
                  onClose={closeLoginPage}
                  onForgotPasswordClick={handleForgotPasswordClick}
                  onRegisterNowClick={handleRegisterNowClick}
                />
              )}

              {showRegistorNow && (
                <RegisterPopup
                  isOpen={showRegistorNow}
                  onClose={closeRegisterPage}
                  onLoginNowClick={handleLoginClick}
                />
              )}

              {showForgotPassword && (
                <div className="modal-background">
                  <ForgotPasswordModal
                    isOpen={showForgotPassword}
                    onClose={() => setShowForgotPassword(false)}
                    onSendButtonClick={handleSaveButtonClick}
                  />
                </div>
              )}

              {showThankYou && (
                <div className="modal-background">
                  <ThankYouModal
                    onLoginNowButtonClick={handleLoginNowButtonClick}
                  />
                </div>
              )}

              <div className="header-right f-right d-none">
                {/* <div className="header-lang f-right pos-rel d-none d-lg-block"> */}
                <div className="d-none">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={languageOptions.find(
                      (option) => option.language_code === selectedLanguage
                    )}
                    components={{
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    options={languageOptions}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        border: "none",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                      }),
                      option: (provided) => ({
                        ...provided,
                        color: "black",
                        backgroundColor: "white",
                        borderBottom: "1px solid #ccc",
                        cursor: "pointer",
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        padding: "0",
                        border: "none",
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                    }}
                    formatOptionLabel={(lang) => (
                      <div
                        className="lang-option"
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "300",
                        }}
                      >
                        <LazyImg
                          src={lang.language_image}
                          alt={lang.language_name}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "8px",
                            border: "2px solid white",
                            borderRadius: "50%",
                          }}
                        />
                        {lang.language_code}
                      </div>
                    )}
                    onChange={(selectedOption) =>
                      handleLanguageChange(selectedOption.language_code)
                    }
                  />
                </div>
              </div>

              <div className="header-right f-right">
                <div className=" f-right pos-rel d-none d-lg-block">
                  <div className="lang-icon">
                    {
                      activeTab === 'Public' ?
                      <HaederMenuPopup /> :
                      <HeaderMenuCorporatePopup />
                    }
                  </div>
                </div>
              </div>

              <div className="side-menu-icon d-lg-none text-end">
                <button
                  onClick={handleShow}
                  className="side-toggle border-0 bg-transparent"
                >
                  <MenuIcon style={{ color: "white" }} />{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Sidebar
        show={show}
        handleClose={handleClose}
        showLoginPage={showLoginPage}
        setShowLoginPage={setShowLoginPage}
        activeTab={activeTab}
      />
    </>
  );
};

export default HomeHeader;
